<template>
  <div class="user-agreement-page">
    <!-- 顶部导航 -->
    <HeaderModel></HeaderModel>

    <div class="back-home" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回首页</span>
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <div class="content-wrapper">
        <h1 class="page-title">隐私政策</h1>

        <div class="publish-date">
          <strong>生效及发布日期：</strong> 2026年3月11日
        </div>

        <p class="intro-text">
          欢迎使用由<strong>北京温致科技有限公司</strong>（以下简称“我们”或“本公司”）提供的健康监测网页版服务（以下简称“本服务”）。我们深知个人信息对您的重要性，并致力于保护您的隐私。本政策将说明我们如何收集、使用、存储及共享您的个人信息。
        </p>

        <!-- 章节一 -->
        <div class="section">
          <h2 class="section-title">一、我们如何收集和使用您的信息</h2>
          <ul class="list-content">
            <li>
              <strong>注册与登录：</strong>
              为了向您提供服务，您需要注册一个账户。我们会收集您的<strong>手机号码以及密码或短信验证码</strong>，仅用于创建、验证和管理您的账户。
            </li>
            <li>
              <strong>健康监测与视频采集：</strong>
              当您使用本服务的核心监测功能时，我们需要获取您的<strong>设备摄像头权限</strong>，以便录制一段30秒的面部视频。我们将基于此视频分析您的心率、心率变异性（HRV）、压力水平和呼吸率等生理指标，并生成AI分析报告。
            </li>
            <li>
              <strong>地理位置限制与安全：</strong>
              本服务仅限中国大陆地区用户使用。我们会收集您的<strong>IP地址</strong>，仅用于验证您的网络环境、限制境外IP的访问请求以及保障账号登录安全。
            </li>
          </ul>
        </div>

        <!-- 章节二 -->
        <div class="section">
          <h2 class="section-title">
            二、我们如何共享您的信息（第三方服务说明）
          </h2>
          <p class="section-content">
            为了实现上述生理数据的核心分析功能，我们集成了第三方的专业分析接口。在您明确授权并使用监测功能时，我们会将您录制的30秒面部视频传输给以下第三方服务提供商：
          </p>
          <ul class="list-content">
            <li><strong>第三方公司名称：</strong> 北京微面科技有限公司</li>
            <li>
              <strong>共享目的与方式：</strong>
              通过API接口加密传输，专用于提取并分析您的心率、HRV、压力水平及呼吸率。
            </li>
            <li>
              <strong>严格的第三方数据限制：</strong>
              我们已与北京微面科技有限公司签署了严格的数据保密及处理协议。我们要求第三方必须遵循“数据最小化”和“用后即焚”原则：<strong
                >仅将视频数据用于提供当次的分析结果，绝不用于其他任何商业或AI训练目的，且在分析完成后必须立即销毁，严禁擅自保留、存储或记录您的面部生物特征信息。</strong
              >
            </li>
          </ul>
        </div>

        <!-- 章节三 -->
        <div class="section">
          <h2 class="section-title">三、信息的存储与安全</h2>
          <ul class="list-content">
            <li>
              <strong>存储地域：</strong>
              我们收集的个人信息及生成的健康监测数据将严格按照中华人民共和国相关法律法规，仅存储于中国大陆境内的服务器上。
            </li>
            <li>
              <strong>数据保留与删除：</strong>
              我们仅在为您提供服务所必需的期间内保留您的信息。当您主动注销账户后，我们将对您的个人手机号及历史健康报告进行彻底删除或不可恢复的匿名化处理。
            </li>
          </ul>
        </div>

        <!-- 章节四 -->
        <div class="section">
          <h2 class="section-title">四、您的权利</h2>
          <p class="section-content">
            您拥有访问、更正、删除您个人信息的权利。您也可以随时在浏览器或设备设置中撤回对摄像头的授权。请注意，撤回摄像头授权或拒绝视频数据共享将导致您无法继续使用本服务的核心健康监测功能。
          </p>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <FooterModel
      style="position: absolute; bottom: 0; left: 0; right: 0"
    ></FooterModel>
  </div>
</template>

<script>
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  components: {
    FooterModel,
    HeaderModel,
  },
  name: "PrivacyPolicy",
  data() {
    return {};
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.replace({ path: "/", force: true });
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .user-agreement-page {
    min-height: 100vh;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    position: relative;
    .back-home{
      display: none;
    }
    .main-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 3rem 2.5rem;
      padding-bottom: 12rem;

      .content-wrapper {
        .page-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .publish-date {
          font-size: 1.2rem;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .intro-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #333333;
          margin-bottom: 2.2rem;

          strong {
            font-weight: 600;
          }
        }

        .section {
          margin-bottom: 2.2rem;

          .section-title {
            font-size: 1.3rem;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 1.1rem;
          }

          .section-content {
            font-size: 1.1rem;
            line-height: 2;
            color: #333333;
            text-align: justify;

            strong {
              font-weight: 600;
            }
          }

          .list-content {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              font-size: 1.1rem;
              line-height: 2;
              color: #333333;
              margin-bottom: 0.77rem;
              padding-left: 1.375rem;
              position: relative;
              text-align: justify;

              &::before {
                content: "•";
                position: absolute;
                left: 0;
                color: #1890ff;
                font-size: 1.76rem;
                line-height: 1;
              }

              strong {
                font-weight: 600;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .back-home {
      width: 42.375rem;
      margin: auto;
      padding-top: 2.625rem;
      display: flex;
      align-items: center;
      color: #333;
      font-weight: 600;
      font-size: 1.75rem;
      color: #4e5361;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
      }
    }
  .user-agreement-page {
    min-height: 100vh;
    background: linear-gradient( 15deg, #F4F1FF 0%, #FFFFFF 45%, #E8F2FF 100%);
    position: relative;

    .main-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 3rem 2.5rem;
      padding-bottom: 14rem;

      .content-wrapper {
        .page-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .publish-date {
          font-size: 1.7rem;
          color: #1a1a1a;
          margin-bottom: 1.65rem;
        }

        .intro-text {
          font-size: 1.6rem;
          line-height: 1.8;
          color: #333333;
          margin-bottom: 2.2rem;

          strong {
            font-weight: 600;
          }
        }

        .section {
          margin-bottom: 2.2rem;

          .section-title {
            font-size: 2rem;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 1.1rem;
          }

          .section-content {
            font-size: 1.6rem;
            line-height: 2;
            color: #333333;
            text-align: justify;

            strong {
              font-weight: 600;
            }
          }

          .list-content {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              font-size: 1.6rem;
              line-height: 2;
              color: #333333;
              margin-bottom: 0.77rem;
              padding-left: 1.375rem;
              position: relative;
              text-align: justify;

              &::before {
                content: "•";
                position: absolute;
                left: -0.4rem;
                color: #1890ff;
                font-size: 3.4rem;
                line-height: 0.8;
              }

              strong {
                font-weight: 600;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>